(ns measure.report-builder.view.core
  (:require ["@mui/material/Accordion$default" :as Accordion]
            ["@mui/material/AccordionDetails$default" :as AccordionDetails]
            ["@mui/material/AccordionSummary$default" :as AccordionSummary]
            ["@mui/material/Alert$default" :as Alert]
            ["@mui/material/Avatar$default" :as Avatar]
            ["@mui/material/Box$default" :as Box]
            ["@mui/material/Button$default" :as Button]
            ["@mui/material/Drawer$default" :as Drawer]
            ["@mui/material/FormControl$default" :as FormControl]
            ["@mui/material/FormHelperText$default" :as FormHelperText]
            ["@mui/material/IconButton$default" :as IconButton]
            ["@mui/material/InputAdornment$default" :as InputAdornment]
            ["@mui/material/Link$default" :as Link]
            ["@mui/material/ListItemIcon$default" :as ListItemIcon]
            ["@mui/material/MenuItem$default" :as MenuItem]
            ["@mui/material/Paper$default" :as Paper]
            ["@mui/material/Select$default" :as Select]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/SvgIcon$default" :as SvgIcon]
            ["@mui/material/TextField$default" :as TextField]
            ["@mui/material/ToggleButton$default" :as ToggleButton]
            ["@mui/material/ToggleButtonGroup$default" :as ToggleButtonGroup]
            ["@mui/material/Typography$default" :as Typography]
            ["react-hook-form" :as rhf]
            ["src/svg/controls/zoom.svg$default" :as Zoom]
            ["src/svg/inform/cross.svg$default" :as Cross]
            [cljs-bean.core :refer [->clj]]
            [clojure.string :as str]
            [common.form :as form]
            [common.ocp.view :refer [ocp]]
            [common.widgets.daterange-picker :as picker]
            [common.widgets.form-field :refer [form-field]]
            [common.widgets.overlay-page :as overlay-page]
            [common.widgets.page :as page]
            [goog.object :as gobject]
            [manage.adset.hooks :as adset.h]
            [manage.adset.util :as adset-util]
            [measure.report-builder.context :as ctx :refer [use-report-builder-context]]
            [measure.report-builder.core :as rbc]
            [measure.report-builder.hooks :as h]
            [measure.report-builder.view.tree :refer [tree-view]]
            [re-frame.core :as rf]
            [uix.core :as uix :refer [$ defui]]))

(defui date-range-field [{:keys [entity control]}]
  ($ form-field
     {:label "Date range"
      :required true}
     (if (= entity :report)
       ($ rhf/Controller
          {:name "date-range"
           :control control
           :render (fn [^js props]
                     (let [{{:keys [error]} :fieldState
                            {:keys [value onChange]} :field} (->clj props)]
                       ($ picker/daterange-picker
                          {:error error
                           :helperText (form/error-message error)
                           :value value
                           :onChange onChange})))})
       ($ form/autocomplete-field
          {:name "date-phrase"
           :control control
           :field-props {:options h/date-phrase-options}}))))

(defui report-scope-form []
  (let [{:keys [step entity mode form-control on-submit on-close]} (use-report-builder-context)
        {:keys [control resetField]} form-control

        channel (rhf/useWatch #js {:control control :name "channel"})
        adset-options (h/use-adset-options channel)]
    ($ Drawer
       {:id "off-canvas"
        :data-testid "off-canvas"
        :anchor "right"
        :variant "temporary"
        :open (= step :scope)
        :onClose on-close
        :PaperProps #js {:elevation 3
                         :sx #js {:width "30%"
                                  :backgroundImage "none"
                                  :borderRadius 0}}}
       ($ ocp
          {:title (if (= entity :report) "Report" "Report schedule")
           :on-submit on-submit
           :on-close on-close
           :footer ($ Stack
                      {:direction "row"
                       :sx #js {:alignSelf "flex-end"
                                :gap 1}}
                      ($ Button
                         {:variant "outlined"
                          :onClick on-close}
                         "Cancel")
                      ($ Button {:variant "contained" :type "submit"}
                         "Open report builder"))}

          ($ form-field
             {:label "Channel"
              :required? true}
             ($ rhf/Controller
                {:name "channel"
                 :control control
                 :render (fn [^js props]
                           (let [{{:keys [error]} :fieldState
                                  {:keys [value onChange]} :field} (->clj props)]
                             ($ FormControl {:error error}
                                ($ Select
                                   {:value (or value "")
                                    :size "small"
                                    :renderValue (fn [value]
                                                   (let [label (:label (first (filter #(= (:value %) value) h/channel-options)))]
                                                     ($ Stack
                                                        {:direction "row"
                                                         :gap 1}
                                                        ($ adset-util/channel-icon {:channel value})
                                                        ($ Typography label))))
                                    :onChange (fn [^js event]
                                                (onChange (-> event .-target .-value))
                                                (resetField "adset-ids" #js {:defaultValue []}))
                                    :sx #js {:width "100%"}}
                                   (for [chan h/channel-options]
                                     ($ MenuItem {:key (:value chan)
                                                  :value (:value chan)}
                                        ($ ListItemIcon
                                           ($ adset-util/channel-icon {:channel (:value chan)}))
                                        (:label chan))))
                                ($ FormHelperText (form/error-message error)))))}))
          ($ form-field
             {:label "Adset(s)"
              :required true}
             ($ form/autocomplete-field
                {:name "adset-ids"
                 :control control
                 :field-props {:options adset-options
                               :multi? true
                               :disable-close-on-select true
                               :filter-options (fn [^js options ^js state]
                                                 (let [input (.toLowerCase (.-inputValue state))]
                                                   (if-not (str/blank? input)
                                                     (.filter options (fn [^js option]
                                                                        (or (str/includes? (.. option -value toString toLowerCase) input)
                                                                            (str/includes? (.. option -label toLowerCase) input)
                                                                            (str/includes? (.. option -campaign toLowerCase) input)
                                                                            (str/includes? (.. option -campaignId toString toLowerCase) input))))
                                                     options)))
                               :no-options-text (cond-> "No options"
                                                  (empty? channel) (str " - Did you select a channel?"))
                               :group-by (fn [^js option]
                                           (.. option -campaign))}}))

          ($ date-range-field {:entity entity :control control})

          ($ form-field
             {:label "Timezone"
              :required true}
             ($ form/autocomplete-field
                {:name "timezone"
                 :control control
                 :field-props {:options h/timezone-options}}))

          (when (= mode :create)
            ($ Alert
               {:severity "info"}
               ($ Typography
                  {:variant "body2"}
                  "This report builder allows you to create fully custom reports with a wide range of data signals, including content and product data."
                  ($ :br)
                  ($ :br)
                  "Need a Content, Split Test, or Product report? "
                  ($ Link
                     {:component "button"
                      :variant "body2"
                      :onClick (fn [e]
                                 (.preventDefault e)
                                 (rf/dispatch [:form.report/open {:entity entity}])
                                 (on-close))
                      :sx #js {:cursor "pointer"}}
                     "Access our legacy report builder")
                  ".")))))))

(defui adset-list-item [{:keys [adset-id]}]
  (let [{:keys [name]} (adset.h/use-adset-id->adset {:adset-id adset-id})]
    ($ :li name)))

(defui dimension-list-item [{:keys [icon label on-delete]}]
  ($ Paper
     {:component Stack
      :direction "row"
      :gap 1
      :sx #js {:alignItems "center"
               :p 1
               "& .delete-button" #js {:opacity 0
                                       :transition "opacity 0.2s"}
               "&:hover .delete-button" #js {:opacity 1}}}
     (when icon
       ($ Avatar
          {:sx (fn [^js theme]
                 #js {:width 32
                      :height 32
                      :backgroundColor "grey.80"
                      "& svg *" #js {:fill (gobject/get (.. theme -palette -grey) "20")}})}
          icon))
     ($ Typography {:fontSize "lg" :fontWeight "600" :sx #js {:flex 1}}
        label)
     ($ IconButton
        {:size "small"
         :onClick on-delete
         :className "delete-button"
         :sx #js {:p 0.5}}
        ($ Cross {:width 20 :height 20}))))

(defui report-content-form []
  (let [{:keys [step entity mode form-control on-submit on-close submit-count]} (use-report-builder-context)
        {:keys [control resetField setValue]} form-control

        {:keys [channel adset-ids send-emails? columns metrics] :as form-values}
        (->clj (rhf/useWatch #js {:control control}))

        [view set-view] (uix/use-state "columns")
        [search set-search] (uix/use-state "")

        email-options (h/use-email-options)

        metric-options (h/use-metric-options channel)
        column-options (h/use-column-options channel)
        tree-items (if (= view "metrics") metric-options column-options)

        filtered-tree-items (uix/use-memo
                             (fn []
                               (if (str/blank? search)
                                 tree-items
                                 (let [search-lower (str/lower-case search)
                                       matches? (fn [{:keys [id label]}]
                                                  (or (str/includes? (str/lower-case label) search-lower)
                                                      (str/includes? (str/lower-case id) search-lower)))]
                                   (keep (fn [item]
                                           (if (:children item)
                                             (let [matching-children (filter matches? (:children item))]
                                               (when (seq matching-children)
                                                 (assoc item :children matching-children)))
                                             (when (matches? item)
                                               item)))
                                         tree-items))))
                             [tree-items search])

        dimension->info (uix/use-memo
                         (fn []
                           (into {}
                                 (for [group (concat metric-options column-options)
                                       child (:children group)]
                                   [(:id child) {:icon (:icon group)
                                                 :label (:label child)}])))
                         [metric-options column-options])

        remove-dimension (uix/use-callback
                          (fn [id field-name]
                            (let [current-values (if (= field-name "metrics") metrics columns)
                                  new-values (filterv #(not= % id) current-values)]
                              (setValue field-name new-values)))
                          [metrics columns setValue])

        generated-name (uix/use-memo
                        (fn []
                          (rbc/generate-report-name form-values entity))
                        [form-values entity])]
    (when (= step :content)
      ($ overlay-page/overlay-page
         ($ overlay-page/header
            {:title (if (= entity :report) "Report" "Report schedule")
             :on-close on-close})
         ($ page/content-padding
            {:sx #js {:pt 3
                      :backgroundColor "grey.90"}}
            ($ Box
               {:component "form"
                :onSubmit on-submit
                :sx #js {:display "grid"
                         :gridTemplateColumns "1fr 2fr 1fr"
                         :gridTemplateRows "1fr"
                         :gap 4
                         :height "100%"}}

               ($ Paper
                  {:component Stack
                   :spacing 2
                   :sx #js {:p 2}}
                  ($ ToggleButtonGroup
                     {:direction "row"
                      :value view
                      :exclusive true
                      :onChange (fn [_e value]
                                  (when value
                                    (set-view value)))
                      :fullWidth true}
                     ($ ToggleButton
                        {:value "columns"}
                        "Columns")
                     ($ ToggleButton
                        {:value "metrics"}
                        "Metrics"))

                  ($ TextField
                     {:placeholder "Search..."
                      :size "small"
                      :fullWidth true
                      :value search
                      :onChange (fn [e]
                                  (set-search (.. e -target -value)))
                      :InputProps #js {:startAdornment
                                       ($ InputAdornment
                                          {:position "start"}
                                          ($ SvgIcon {:component Zoom}))}})

                  ($ tree-view
                     {:key view
                      :field-name (if (= view "metrics") "metrics" "columns")
                      :control control
                      :tree-items filtered-tree-items}))

               ($ Paper
                  {:component Stack
                   :gap 2
                   :sx #js {:p 2}}
                  ($ Typography {:fontWeight 600} "Columns")
                  (when-let [missing (cond
                                       (and (empty? metrics) (empty? columns)) "metric(s) and column(s)"
                                       (empty? metrics) "metric(s)"
                                       (empty? columns) "column(s)"
                                       :else nil)]
                    ($ Alert
                       {:severity (if (> submit-count 1) "warning" "info")}
                       (str "Select " missing " from the left panel to build your report")))
                  ($ Stack {:gap 1}
                     (for [[id field-name] (concat (map vector (reverse columns) (repeat "columns"))
                                                   (map vector (reverse metrics) (repeat "metrics")))
                           :let [{:keys [icon label]} (get dimension->info id)]]
                       ($ dimension-list-item
                          {:key id
                           :label label
                           :icon icon
                           :on-delete #(remove-dimension id field-name)}))))

               ($ Paper
                  {:component Stack
                   :gap 2
                   :sx #js {:p 2}}
                  ($ Paper
                     {:component Stack
                      :gap 1
                      :elevation 0
                      :sx #js {:p 1.5
                               :pt 1}}
                     ($ Typography {:fontWeight 600} "Overview")
                     ($ form-field
                        {:label "Adset(s)"}
                        ($ Accordion
                           ($ AccordionSummary
                              {:sx #js {:flexDirection "row"
                                        ".MuiAccordionSummary-content" #js {:alignItems "center"}}}
                              ($ adset-util/channel-icon {:channel channel})
                              ($ Typography (str (count adset-ids) " selected")))
                           ($ AccordionDetails
                              ($ Stack
                                 {:component "ul"
                                  :sx #js {:margin 0}}
                                 (for [adset-id adset-ids]
                                   ($ adset-list-item {:key adset-id :adset-id adset-id}))))))
                     ($ date-range-field {:entity entity :control control}))
                  ($ Paper
                     {:component Stack
                      :gap 1
                      :elevation 0
                      :sx #js {:p 1.5
                               :pt 1}}
                     ($ Typography {:fontWeight 600} "Settings")
                     ($ form-field
                        {:label "File type"}
                        ($ form/radio-group
                           {:name "file-format"
                            :control control
                            :field-props {:options h/format-options
                                          :row true}}))
                     ($ form-field
                        {:label "Report name"}
                        ($ form/form-text-field
                           {:name "name"
                            :control control
                            :field-props {:placeholder generated-name}}))

                     (when (= entity :report-schedule)
                       ($ form-field
                          {:label "Schedule interval"}
                          ($ form/radio-group
                             {:name "schedule"
                              :control control
                              :field-props {:options h/schedule-options}}))))

                  ($ form/switch
                     {:name "send-emails?"
                      :control control
                      :label "Send reports via e-mail"
                      :on-after-change #(resetField "email" #js {:defaultValue []})})

                  (when send-emails?
                    ($ form-field
                       {:label "Send report to"}
                       ($ form/autocomplete-field
                          {:name "email"
                           :control control
                           :field-props {:multi? true
                                         :options email-options}})))

                  ($ Button
                     {:variant "contained"
                      :type "submit"}
                     (cond
                       (= entity :report) "Run report"
                       (= mode :create) "Create report schedule"
                       :else "Edit report schedule")))))))))

(defui report-builder []
  ($ :<>
     ($ report-scope-form)
     ($ report-content-form)))
